export { HeaderOwndaysPc } from './HeaderOwndaysPc';
export { BodyOwndaysPc } from './BodyOwndaysPc';
export { FooterOwndaysPc } from './FooterOwndaysPc';
